<template>
  <span :data-test="`recruiter-submission-limit-${rowIndex}`">{{
    column.maxCandidateSubmissions ?? '-'
  }}</span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const CompanyRecruiterSubmissionLimitColumn = graphql(`
  fragment CompanyRecruiterSubmissionLimitColumn on CompanyRecruiter {
    maxCandidateSubmissions
  }
`)

const props = defineProps<{
  row: FragmentType<typeof CompanyRecruiterSubmissionLimitColumn>
  rowIndex?: number
}>()
const column = computed(() => useFragment(CompanyRecruiterSubmissionLimitColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
